var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Drawer, useMediaQuery, useTheme } from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';
import { Fragment, useEffect, useRef, useState } from 'react';
import { useLazyGetAnswerQuery, useLazyGetTranslationAnswerQuery, useLikeAnswerMutation, useNeutralAnswerMutation } from '../../../../application/features/chat/chat-api';
import { setSideBarState } from '../../../../application/features/common/commonSlice';
import { useSynthesizeSpeechMutation } from '../../../../application/features/microsoft-speech/microsoft-speech-api';
import { useAppDispatch, useAppSelector } from '../../../../application/store/useStore';
import useTranslate from '../../../../localization/helpers';
import ChatFeedback from '../chat-section/chat-feedback';
import ChatHeader from './chat-header';
import ChatHistoryDrawer from './chat-header/chat-history-drawer';
import ChatInput from './chat-input';
import AIMessage from './components/ai-message';
import FileViewerDialog from './components/ai-message/file-viewer';
import UserMessage from './components/user-message';
var ChatSection = function (_a) {
    var conversation = _a.conversation, messageId = _a.messageId;
    var theme = useTheme();
    var _b = useTranslate(), translate = _b.translate, tWithField = _b.tWithField;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isIpad = useMediaQuery('(min-width: 768px) and (max-width: 1024px)');
    var _c = __read(useState(false), 2), isExpanded = _c[0], setIsExpanded = _c[1];
    var toggleExpanded = function () { return setIsExpanded(!isExpanded); };
    var dispatch = useAppDispatch();
    var chatEndRef = useRef(null);
    var _d = __read(useState(false), 2), isAccordionExpanded = _d[0], setIsAccordionExpanded = _d[1];
    var _e = __read(useState([]), 2), selectedSources = _e[0], setSelectedSources = _e[1];
    var _f = __read(useState(), 2), selectedDocument = _f[0], setSelectedDocument = _f[1];
    var _g = __read(useState(), 2), selectedSource = _g[0], setSelectedSource = _g[1];
    var _h = __read(useState([]), 2), selectedDocContent = _h[0], setSelectedDocContent = _h[1];
    var _j = __read(useState(''), 2), selectedMessageId = _j[0], setSelectedMessageId = _j[1];
    var _k = __read(useState(''), 2), selectedDocumentName = _k[0], setSelectedDocumentName = _k[1];
    var _l = __read(useState(true), 2), shouldScroll = _l[0], setShouldScroll = _l[1];
    var _m = __read(useState(''), 2), selectedUuid = _m[0], setSelectedUuid = _m[1];
    var _o = __read(useState(''), 2), selectedScrollId = _o[0], setSelectedScrollId = _o[1];
    var _p = __read(useState(false), 2), isDrawerOpen = _p[0], setIsDrawerOpen = _p[1];
    var _q = __read(useState(false), 2), isDocumentViewOpen = _q[0], setIsDocumentViewOpen = _q[1];
    var _r = __read(useState(), 2), readAloudMessageId = _r[0], setReadAloudMessageId = _r[1];
    var _s = __read(useState({ isOpen: false }), 2), dislikeMessage = _s[0], setDislikeMessage = _s[1];
    var sideBar = useAppSelector(function (state) { return state.common; }).sideBar;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var conversation_id = useAppSelector(function (state) { return state.chat; }).conversation_id;
    var _t = __read(useLazyGetAnswerQuery(), 2), getAnswer = _t[0], _u = _t[1], answer = _u.data, getAnswerFetching = _u.isFetching, answerSuccess = _u.isSuccess;
    var _v = __read(useLazyGetTranslationAnswerQuery(), 2), getTranslation = _v[0], getTranlsationAnswerFetching = _v[1].isFetching;
    var _w = __read(useSynthesizeSpeechMutation(), 1), synthesizeSpeech = _w[0];
    var _x = __read(useLikeAnswerMutation(), 2), likeAnswer = _x[0], isLikeAnswerSuccess = _x[1].isSuccess;
    var _y = __read(useNeutralAnswerMutation(), 1), neutralAnswer = _y[0];
    var _z = conversation !== null && conversation !== void 0 ? conversation : {}, _0 = _z.messages, messages = _0 === void 0 ? [] : _0, _1 = _z.document_list, document_list = _1 === void 0 ? [] : _1, _2 = _z.faqs, faqs = _2 === void 0 ? [] : _2;
    var audioContextRef = useRef(null);
    var audioBufferSourceRef = useRef(null);
    var selectedVoice = 'en-GB-OllieMultilingualNeural';
    useEffect(function () {
        var _a;
        shouldScroll && ((_a = chatEndRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [conversation]);
    useEffect(function () {
        setIsDocumentViewOpen(false);
    }, [conversation_id]);
    useEffect(function () {
        if (!getAnswerFetching) {
            var lastMessage = messages.at(-1);
            if (lastMessage) {
                setSelectedSources(lastMessage.sources);
                setSelectedDocContent(lastMessage.doc_content);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getAnswerFetching]);
    useEffect(function () {
        if (!getTranlsationAnswerFetching) {
            var lastMessage = messages.at(-1);
            if (lastMessage) {
                setSelectedSources(lastMessage.sources);
                setSelectedDocContent(lastMessage.doc_content);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getTranlsationAnswerFetching]);
    useEffect(function () {
        if (isLikeAnswerSuccess) {
            enqueueSnackbar(tWithField('toolTips.submitSuccess', 'common.feedback'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            setShouldScroll(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLikeAnswerSuccess]);
    useEffect(function () {
        var stopSpeech = function () { return stopCurrentAudio(); };
        window.addEventListener('beforeunload', stopSpeech);
        return function () {
            window.removeEventListener('beforeunload', stopSpeech);
        };
    }, []);
    useEffect(function () {
        return function () { return stopCurrentAudio(); };
    }, []);
    useEffect(function () {
        if (answer && answerSuccess && answer.question_type === 'audio') {
            var plainText = answer.response.replace(/[#_*~`>[\]]/g, '').trim();
            readAloud(plainText, answer.message_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [answer, answerSuccess]);
    var sendQuestion = function (question, questionType) {
        var chatQuestion = {
            question: question,
            question_type: questionType,
            user_id: currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId,
            conversation_id: conversation_id
        };
        getAnswer(chatQuestion);
    };
    var handleUuidSelection = function (uuid) {
        setSelectedUuid(uuid);
        setSelectedScrollId(nanoid());
    };
    var handleTranslatedTextSelection = function (text) {
        if (text !== '') {
            var chatQuestion = {
                question: '',
                user_id: currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId,
                conversation_id: conversation_id,
                response: text
            };
            getTranslation(chatQuestion);
        }
    };
    var handleSourceSelection = function (contentDto) {
        if (contentDto.doc_content_id) {
            var filteredChatDtos = messages
                .map(function (chatDto) {
                var filteredSource = chatDto.sources.find(function (source) { return source.document === contentDto.document && source.page === contentDto.page; });
                return filteredSource || null;
            })
                .filter(function (source) { return source !== null; })[0];
            setSelectedDocumentName(contentDto.document);
            setSelectedSource(filteredChatDtos);
            setSelectedDocument(conversation === null || conversation === void 0 ? void 0 : conversation.document_list.find(function (x) { return x.document_name === contentDto.document; }));
        }
    };
    var handleContentSelection = function (contentDtos, content_id) {
        var _a;
        setSelectedDocContent([]);
        var documentName = ((_a = contentDtos.find(function (content) { return content.doc_content_id === content_id; })) === null || _a === void 0 ? void 0 : _a.document) || '';
        var contents = contentDtos.filter(function (content) { return content.document === documentName; });
        setSelectedDocContent(contents);
    };
    var handleSourcesSelection = function (messageId) {
        var message = messages.find(function (message) { return message.message_id === messageId; });
        if (message) {
            setSelectedSources(message.sources);
            setSelectedMessageId(messageId);
        }
    };
    var openChatFeedbackDislike = function (chat) {
        setShouldScroll(false);
        setDislikeMessage({
            isOpen: true,
            chat: chat
        });
    };
    var closeChatFeedbackDislike = function () {
        setShouldScroll(true);
        setDislikeMessage({ isOpen: false });
    };
    var likeChat = function (chat) {
        setShouldScroll(false);
        likeAnswer({
            conversationId: conversation_id,
            messageId: chat.message_id,
            userId: currentUser.userId
        });
    };
    var neutralChat = function (chat) {
        setShouldScroll(false);
        neutralAnswer({
            conversationId: conversation_id,
            messageId: chat.message_id,
            userId: currentUser.userId
        });
    };
    var toggleAccordion = function () {
        setIsAccordionExpanded(!isAccordionExpanded);
    };
    var handleViewDocumentOpen = function (chatDto) {
        if (sideBar.isOpen)
            dispatch(setSideBarState({
                isOpen: false,
                reason: 'system'
            }));
        setSelectedSources(chatDto.sources);
        setSelectedDocContent(chatDto.doc_content);
        setSelectedMessageId(chatDto.message_id);
        setIsDocumentViewOpen(true);
    };
    var handleViewDocumentClose = function () {
        setIsDocumentViewOpen(false);
        if (!sideBar.isOpen && sideBar.reason === 'system')
            dispatch(setSideBarState({
                isOpen: true,
                reason: 'user'
            }));
    };
    var generateAzureSpeech = function (plainText) { return __awaiter(void 0, void 0, void 0, function () {
        var audioData, audioContext, audioBuffer, source_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, synthesizeSpeech({
                            text: plainText,
                            voiceName: selectedVoice,
                            language: 'nl-NL',
                            rate: '1',
                            outputFormat: 'audio-16khz-32kbitrate-mono-mp3'
                        }).unwrap()];
                case 1:
                    audioData = _b.sent();
                    audioContext = new AudioContext();
                    audioContextRef.current = audioContext;
                    return [4 /*yield*/, audioContext.decodeAudioData(audioData)];
                case 2:
                    audioBuffer = _b.sent();
                    source_1 = audioContext.createBufferSource();
                    source_1.buffer = audioBuffer;
                    source_1.connect(audioContext.destination);
                    source_1.start(0);
                    audioBufferSourceRef.current = source_1;
                    source_1.onended = function () {
                        setReadAloudMessageId(undefined);
                        source_1.disconnect();
                    };
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    enqueueSnackbar('Error generating speech', {
                        variant: 'error',
                        autoHideDuration: 3000,
                        anchorOrigin: { horizontal: 'right', vertical: 'top' }
                    });
                    setReadAloudMessageId(undefined);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var readAloud = function (plainText, messageId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            stopCurrentAudio();
            if (readAloudMessageId === messageId) {
                setReadAloudMessageId(undefined);
            }
            else {
                setReadAloudMessageId(messageId);
                generateAzureSpeech(plainText);
            }
            return [2 /*return*/];
        });
    }); };
    var handleReadAloud = function (chat) {
        stopCurrentAudio();
        if (readAloudMessageId === chat.message_id) {
            setReadAloudMessageId(undefined);
        }
        else {
            setReadAloudMessageId(chat.message_id);
            var plainText = chat.answer.replace(/[#_*~`>[\]]/g, '').trim();
            generateAzureSpeech(plainText);
        }
    };
    var stopCurrentAudio = function () {
        if (audioBufferSourceRef.current) {
            audioBufferSourceRef.current.stop();
            audioBufferSourceRef.current.disconnect();
            audioBufferSourceRef.current = null;
        }
        if (audioContextRef.current) {
            audioContextRef.current.close();
            audioContextRef.current = null;
        }
    };
    useEffect(function () {
        if (messageId) {
            var messageElement = document.getElementById("ai-message-".concat(messageId));
            if (messageElement) {
                messageElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }, [messageId, messages]);
    return (_jsxs(Fragment, { children: [_jsxs(Box, { height: { xs: '100%' }, display: 'flex', flexDirection: 'column', width: isDocumentViewOpen && !isXs && !isIpad ? (isExpanded ? '30%' : '50%') : '100%', sx: {
                    backgroundColor: theme.palette.background.default,
                    borderBottomLeftRadius: '24px !important',
                    borderTopLeftRadius: '24px !important ',
                    borderTopRightRadius: isDocumentViewOpen && !isXs && !isIpad ? '0px !important' : undefined,
                    borderBottomRightRadius: isDocumentViewOpen && !isXs && !isIpad ? '0px !important' : undefined,
                    borderRadius: { xs: 2 },
                    boxShadow: '0 10px 48px 0 #919EAB29',
                    overflowY: 'hidden',
                    position: 'relative'
                }, children: [_jsx(ChatHeader, { toggleAccordion: toggleAccordion, isAccordionExpanded: isAccordionExpanded, messages: messages, faqs: faqs, documents: document_list, conversationId: conversation_id, userId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId, openDrawer: function () { return setIsDrawerOpen(true); }, isExpanded: isExpanded }), _jsxs(Box, { sx: {
                            flexGrow: 1,
                            padding: '16px 20px',
                            overflowY: 'auto',
                            marginTop: '60px'
                        }, children: [messages.map(function (chat, index) { return (_jsxs(Fragment, { children: [_jsx("div", { id: "user-message-".concat(index), children: _jsx(UserMessage, { message: chat.question, question_type: chat.question_type, time: new Date(chat.time).toLocaleTimeString(translate('common.dateLanguageCode2'), {
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: true
                                            }) }) }), _jsx("div", { id: "ai-message-".concat(chat.message_id), children: _jsx(AIMessage, { chat: chat, onReadAloud: function () { return handleReadAloud(chat); }, isFirstMessage: index === 0, readingAloud: chat.message_id === readAloudMessageId, isFetching: (getAnswerFetching || getTranlsationAnswerFetching) &&
                                                index === messages.length - 1, onDislike: function () { return openChatFeedbackDislike(chat); }, onLike: function () { return likeChat(chat); }, onNeutral: function () { return neutralChat(chat); }, onViewDocumentClose: handleViewDocumentClose, onViewDocumentOpen: function () { return handleViewDocumentOpen(chat); }, onUuidSelect: handleUuidSelection, onDocContentSelect: handleSourceSelection, onDocContentsSelect: handleContentSelection, onSourcesSelect: function () { return handleSourcesSelection(chat.message_id); }, isExpanded: isExpanded }) })] }, chat.message_id)); }), _jsx("div", { ref: chatEndRef })] }), _jsx(ChatInput, { disabled: getAnswerFetching, sendMessage: sendQuestion }), _jsx(ChatHistoryDrawer, { setIsOpen: setIsDrawerOpen, isOpen: isDrawerOpen })] }), isDocumentViewOpen &&
                (!isXs && !isIpad ? (_jsx(Box, { width: isExpanded ? '70%' : '50%', height: '100%', bgcolor: '#F4F6F8', sx: { borderTopLeftRadius: 0 }, children: _jsx(FileViewerDialog, { open: isDocumentViewOpen, message_id: selectedMessageId, onClose: handleViewDocumentClose, OnTranslatedTextSelection: handleTranslatedTextSelection, isFetching: getAnswerFetching, source: selectedSource, sources: selectedSources, sourceDocument: selectedDocument, doc_content: selectedDocContent, hash_id: selectedUuid, scroll_id: selectedScrollId, document_name: selectedDocumentName, isActualChat: true, toggleExpanded: toggleExpanded, isExpanded: isExpanded, setIsExpanded: setIsExpanded }) })) : (_jsx(Drawer, { anchor: isXs ? 'bottom' : 'right', open: isDocumentViewOpen, onClose: function () { return setIsDocumentViewOpen(false); }, sx: {
                        '& .MuiDrawer-paper': {
                            height: '100%',
                            width: isIpad ? '500px' : undefined,
                            borderTopLeftRadius: 16,
                            borderTopRightRadius: 16,
                            overflow: 'hidden'
                        }
                    }, children: _jsx(FileViewerDialog, { open: isDocumentViewOpen, message_id: selectedMessageId, onClose: handleViewDocumentClose, OnTranslatedTextSelection: handleTranslatedTextSelection, sources: selectedSources, isFetching: getAnswerFetching, source: selectedSource, sourceDocument: selectedDocument, doc_content: selectedDocContent, hash_id: selectedUuid, scroll_id: selectedScrollId, document_name: selectedDocumentName, isActualChat: true, toggleExpanded: toggleExpanded, isExpanded: isExpanded, setIsExpanded: setIsExpanded }) }))), dislikeMessage.chat && (_jsx(ChatFeedback, { isOpen: dislikeMessage.isOpen, onClose: closeChatFeedbackDislike, dislikedMessage: dislikeMessage.chat }))] }));
};
export default ChatSection;
